export const DEFAULT_SCENARIO = {
  id: 'default',
  name: 'Base Case',
  description: 'Default Financial Climate',
};

const STRATEGIES = {
  targetRetirementAge: {
    conservative: 65,
    moderate: 65,
  },
  averageIncomeGrowthRate: {
    scaler: 100,
    offset: 1,
    conservative: 1.02,
    moderate: 1.04,
  },
  averagePrivateAssetGrowthRate: {
    scaler: 100,
    offset: 1,
    conservative: 1.05,
    moderate: 1.07,
  },
  taxRateRetention: {
    scaler: 100,
    offset: 0,
    conservative: 0.6,
    moderate: 0.65,
  },
  annualInflationRate: {
    scaler: 100,
    offset: 1,
    conservative: 1.035,
    moderate: 1.03,
  },
  averageRealEstateGrowthRate: {
    scaler: 100,
    offset: 1,
    conservative: 1.02,
    moderate: 1.03,
  },
  averageEquityGrowthRate: {
    scaler: 100,
    offset: 1,
    conservative: 1.03,
    moderate: 1.04,
  },
  averageEquityWithdrawalRate: {
    scaler: 100,
    offset: 0,
    conservative: 0.04,
    moderate: 0.035,
  },
  averageRetirementEquityWithdrawalRate: {
    scaler: 100,
    offset: 0,
    conservative: 0.04,
    moderate: 0.035,
  },
  socialSecurityIncome: {
    conservative: 2500,
    moderate: 3500,
  },
};

export default STRATEGIES;
